<template>
  <div>
    <benefits-transactions-table @showEditTransactionModal="showEditTransactionModal"></benefits-transactions-table>
    <transaction-edit-modal
      v-if="showEditTransactionModalFlag"
      :open.sync="showEditTransactionModalFlag"
      :transactionId.sync="transactionToEditId"
      benefitTransactionMode
      @showTransactionModal="showTransactionModal"
    ></transaction-edit-modal>
  </div>
</template>

<script>
import BenefitsTransactionsTable from '../../_components/transactions/BenefitsTransactionsTable'
const TransactionEditModal = () => import('@/modules/transactions/_components/_shared/TransactionsEditModal')
export default {
  name: 'TransactionsBenefitsIndex',
  components: { BenefitsTransactionsTable, TransactionEditModal },
  data () {
    return {
      transactionToEditId: 0,
      showEditTransactionModalFlag: false
    }
  },
  methods: {
    fetchBenefitsTransactions (event) {
      const defaultFilters = {
      }
      let searchFilters = {}
      if (event && event.length >= 3) {
        searchFilters.query = event
      }

      const filters = { ...defaultFilters, ...searchFilters }
      this.$store.dispatch('TransactionsStore/setFlexibleRemunerationFilters', filters)
    },
    showEditTransactionModal (event) {
      this.transactionToEditId = event
      this.showEditTransactionModalFlag = true
      this.showFilterModalFlag = false
    }

  },
  async created () {
    this.$store.dispatch('TransactionsStore/clearStore')
    await this.fetchBenefitsTransactions()
  }
}
</script>
